import React from 'react';
import classNames from 'classnames';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import EnhancedTableHead from '../../utils/EnhancedTableHead';
import { commonTablestyles } from '../../utils/Style';
import ReactTable from 'react-table';
import '../../css/react-table/react-table.css';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    loadingHeight: {
        height: "100%",
        position: "fixed",
        top: "0",
        right: "0"
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        width: 350
    },
    button: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 10
    },
    alreadySignIn: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto"
    },
    success: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        
        marginRight: "auto",
        color: "green"
    }
});
class UserListTable extends React.Component {

    renderEditable(cellInfo) {  
        return (
          <div
            style={{ backgroundColor: "#fafafa" }}
            contentEditable
            suppressContentEditableWarning
            onBlur={e => {
              const data = [...this.state.data];
              data[cellInfo.index][cellInfo.column.id] = e.target.innerHTML;
              const editedData_ = [...this.state.editedData];
              editedData_.push(data[cellInfo.index])
              this.setState({editedData:editedData_  });
              console.log(editedData_)
            }}
            dangerouslySetInnerHTML={{
             __html: this.state.data[cellInfo.index][cellInfo.column.id]
            }}
          />
        );
      }
    
    state = {
        open: false,
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            objects: [],
            selected: [],
            data:this.props.data,
            order: 'asc',
            orderBy: '',
            page: 0,
            editedData:[],
        };
        this.renderEditable = this.renderEditable.bind(this);
        this.handleEditedContent = this.props.handleEditedContent.bind(this);
        this.handleChangeUserStatus = this.props.handleChangeUserStatus.bind(this);
    }
 
    componentDidUpdate(prevProps,prevState){
        if(prevState.editedData !== this.state.editedData){  
              this.handleEditedContent(this.state.editedData);

        }
    }
 

    static getDerivedStateFromProps(props, state) { 
        if (props.data !== state.data) {
          return{ data: props.data };
        }
        else
        return null;

    }
 
 
    isSelected = id => this.state.selected.indexOf(id) !== -1;

    renderReactTable(data,classes,columns){
        
        return (
            <Paper>
            <Grid container className={classes.root}>
                    <Grid item xs={12}>
                            <Grid container justify='center' alignItems='center'>
                                User List

                            </Grid>
                            <Grid container justify='center' alignItems='center'>
                                <ReactTable 
                                    className="-striped -highlight"
                                    defaultPageSize={10}
                                    data={ data}
                                    columns={columns}
                                    style={{width:'99%'}}
                                >

                                </ReactTable>

                            </Grid>
                    </Grid>
                    </Grid>
                     
            </Paper>
        );
    }

    render() {
        
 const columns = [  {
                
    "Header": "ID",
    Cell : props => props.index + 1
},
    {
     
    "Header": "Date created",
    "accessor": 'datetime_created', 
    }, 
    {
    "Header": "Company Group",
    "accessor": 'company', 
    },
    {
        "Header": "Username",
        "accessor":'username', 
     },
     {
        "Header": "Email",
        "accessor": "email",
        Cell:this.renderEditable 

    },
    
    {
        "Header": "Status",
        "accessor": "status",
    },
    
    {
        "Header": "Action", 
        minWidth: 300,
        Cell: props =>{
            if(props.row.status === 'active')
            return(<Button variant="contained" 
            color="primary" onClick={e=>this.handleChangeUserStatus(props.row.username)}>Change To Inactive</Button>)
            else if (props.row.status === 'inactive')
            return(<Button variant="contained"
            color="primary" onClick={e=>this.handleChangeUserStatus(props.row.username)} >Change To Active</Button>)
        }
    }];
     
        const { classes, columnData, handleChangeRowsPerPage, handleModalOpen, handleChangePage, countuserValue, rowsPerPage, emptyRows, selected, handleClick, handleSelectAllClick } = this.props;
        const { objects, order, orderBy, page,data } = this.state;
        return (
           
        this.renderReactTable( data, classes, columns)
        );
    }
}

export default withStyles(commonTablestyles)(UserListTable);


// WEBPACK FOOTER //
// ./src/utils/MainTable/UserListTable.js